// eslint-disable-next-line no-restricted-imports
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Captures a PostHog `$pageview` on every route change.
 *
 * Only the route location is reported: query params are stripped from the url
 * properties by `stripUrlQueries` in the PostHog provider.
 *
 * `/` and paths with a trailing slash are not reported: `StaffRootRoutes` immediately
 * redirects them to their canonical path, so capturing both doubles the pageview.
 */
export function usePostHogPageViewEffect() {
  const posthog = usePostHog();
  const { pathname } = useLocation();

  /**
   * This effect has been reviewed by a staff+ ui engineer and is considered safe to use.
   */
  useEffect(() => {
    if (pathname.endsWith('/')) {
      return;
    }
    posthog?.capture('$pageview');
  }, [posthog, pathname]);
}
